// 组件对象，大写
import panguDatePicker from './panguDatePicker.vue'
export default panguDatePicker
